import { definePreset } from '@primevue/themes'
import Aura from '@primevue/themes/aura'
import { createPinia } from 'pinia'
import PrimeVue from 'primevue/config'
import ConfirmationService from 'primevue/confirmationservice'
import ToastService from 'primevue/toastservice'
import Tooltip from 'primevue/tooltip'
import { createApp } from 'vue'

import App from './App.vue'
import './assets/main.css'
import i18n from './libs/i18n'
import { setupVeeValidate } from './libs/veeValidate'
import router from './router'

const Noir = definePreset(Aura, {
    semantic: {
        primary: {
            50:  'var(--color-primary-50)',
            100: 'var(--color-primary-100)',
            200: 'var(--color-primary-200)',
            300: 'var(--color-primary-300)',
            400: 'var(--color-primary-400)',
            500: 'var(--color-primary-500)',
            600: 'var(--color-primary-600)',
            700: 'var(--color-primary-700)',
            800: 'var(--color-primary-800)',
            900: 'var(--color-primary-900)',
            950: 'var(--color-primary-950)',
        },
    },
})

setupVeeValidate()

const app = createApp(App)

app.use(createPinia())
app.use(i18n)
app.use(ConfirmationService)
app.use(ToastService)
app.directive('tooltip', Tooltip)
app.use(PrimeVue, {
    theme: {
        preset: Noir,
        options: {
            cssLayer: { name: 'primevue', order: 'theme, base, primevue' },
            darkModeSelector: '.dark',
        },
    },
})

app.use(router)

// Keep the document empty until Vue Router has resolved the initial URL and
// completed its authentication guard. Mounting before isReady() briefly renders
// the authenticated shell with the router's default route metadata when a
// signed-out visitor opens /signup or /login.
router.isReady().then(() => {
    app.mount('#app')
})
